import type { FieldValues } from 'react-hook-form';

export const getPriceFixedOnDate = (data: FieldValues): string | undefined => {
  if (!data.price_as_index_pct_enabled) {
    return undefined;
  }

  return data.price_as_index_percentage_fixed_on_date_options === 'other'
    ? data.price_as_index_percentage_fixed_on_date_other_details
    : 'Day of collection';
};

export const generatePriceFieldValues = (data: FieldValues) => {
  if (data.price_as_index_pct_enabled) {
    return {
      price_as_index_percentage: data.price_as_index_percentage.toString(),
      price_as_index_percentage_fixed_on: data.price_as_index_percentage_fixed_on_options,
      price_as_index_percentage_fixed_on_date: getPriceFixedOnDate(data),
      price_index: data.price_index,
      ...(data.price_as_index_percentage_fixed_on_options === 'OTHER'
        ? { notes: `Price fixed at: ${data.price_as_index_percentage_fixed_on_other_details}` }
        : {}),
    };
  } else {
    return {};
  }
};
